import { create } from 'zustand';
import { Task } from '../types';

interface TaskStore {
  tasks: Task[];
  activeTaskId: string | null;
  addTask: (task: Omit<Task, 'id' | 'createdAt' | 'updatedAt'>) => string;
  updateTask: (id: string, updates: Partial<Task>) => void;
  removeTask: (id: string) => void;
  getTask: (id: string) => Task | undefined;
  getActiveTask: () => Task | undefined;
  setActiveTask: (id: string | null) => void;
}

export const useTaskStore = create<TaskStore>((set, get) => ({
  tasks: [],
  activeTaskId: null,

  addTask: (task) => {
    const id = `task-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
    const newTask: Task = {
      ...task,
      id,
      createdAt: new Date(),
      updatedAt: new Date(),
    };

    set((state) => ({
      tasks: [...state.tasks, newTask],
    }));

    return id;
  },

  updateTask: (id, updates) => {
    set((state) => ({
      tasks: state.tasks.map((task) =>
        task.id === id
          ? { ...task, ...updates, updatedAt: new Date() }
          : task
      ),
    }));
  },

  removeTask: (id) => {
    set((state) => ({
      tasks: state.tasks.filter((task) => task.id !== id),
      activeTaskId: state.activeTaskId === id ? null : state.activeTaskId,
    }));
  },

  getTask: (id) => {
    return get().tasks.find((task) => task.id === id);
  },

  getActiveTask: () => {
    const { activeTaskId, tasks } = get();
    return tasks.find((task) => task.id === activeTaskId);
  },

  setActiveTask: (id) => {
    set({ activeTaskId: id });
  },
}));